import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import AboutUsCardLeft from '../../assets/images/about_us_card_left.svg';
import AboutUsCardRight from '../../assets/images/about_us_card_right.svg';
import { brandTokens } from '../single-page/theme';

const RootGrid = styled(Grid)(({ theme }) => ({
  position: 'relative',
  minHeight: '450px',
  width: '100%',
  margin: 0,
  padding: '132px 32px 132px 32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: brandTokens.tonal,
  [theme.breakpoints.down('sm')]: {
    padding: '66px 16px 80px 16px',
  },
}));

const CardsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  width: '100%',
  maxWidth: '1200px',
  margin: '0 auto',
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    gap: theme.spacing(8),
  },
}));

const Card = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.06)',
  border: '1px solid rgba(107, 211, 253, 0.15)',
  borderRadius: 16,
  padding: theme.spacing(3),
  flex: 1,
  width: '50%',
  position: 'relative',
  overflow: 'visible',
  [theme.breakpoints.down('md')]: {
    width: '100%',
    marginBottom: 0,
    padding: theme.spacing(4),
    '&:first-of-type': {
      marginBottom: theme.spacing(8),
    },
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  color: '#fff',
  marginBottom: theme.spacing(2),
  paddingTop: theme.spacing(5),
  fontWeight: 600,
  fontSize: '24px',
  [theme.breakpoints.down('md')]: {
    paddingTop: theme.spacing(2),
  },
  [theme.breakpoints.down('sm')]: {
    paddingTop: theme.spacing(2),
  },
}));

const Content = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '16px',
  '& + &': {
    marginTop: theme.spacing(3),
  },
  '& strong': {
    fontWeight: 'bold',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

const Image = styled('img')(({ theme }) => ({
  width: '50%',
  height: 'auto',
  position: 'absolute',
  left: '50%',
  top: '0',
  transform: 'translate(-50%, -50%)',
  borderRadius: '8px',
  [theme.breakpoints.down('md')]: {
    width: '40%',
  },
}));

const RightCardTitle = styled(Typography)(({ theme }) => ({
  color: '#fff',
  fontSize: '20px',
  marginTop: '18%',
  fontWeight: 'bold',
  marginBottom: theme.spacing(2),
}));

const LeftImage = styled('img')(({ theme }) => ({
  width: '200px',
  height: '200px',
  position: 'absolute',
  left: '-60px',
  top: '-95px',
  borderRadius: '8px',
  [theme.breakpoints.down('md')]: {
    width: '110px',
    height: '110px',
    left: '-15px',
    top: '-40px',
  },
}));

const AboutUs = () => {
  return (
    <RootGrid>
      <CardsContainer>
        <Card>
          <LeftImage 
            src={AboutUsCardLeft} 
            alt="Ícone de verificação"
          />
          <Title variant="h4">
            Sobre nós
          </Title>
          <Content>
            A Autovalid é uma empresa que atua no mercado de vistoria cautelar. 
            Além das informações de histórico de leilão, restrições, débitos, 
            conferência de originalidade, análises de carroceria, pintura e
            estrutura do veículo, fornecemos o diagnóstico do motor e da parte
            eletrônica do automóvel, através de um dispositivo conectado no
            veículo e da nossa tecnologia.
          </Content>
          <Content>
            Nós utilizamos I.A. (inteligência artificial) para aprovação ou reprovação do laudo de vistoria, 
            entregando bem mais assertividade e confiança para o nosso cliente e para o mercado automotivo.
          </Content>
        </Card>

        {/* Card da direita */}
        <Card>
          <Image 
            src={AboutUsCardRight} 
            alt="Logo sobre nós"
          />
          <RightCardTitle>
            Vistoria Cautelar Automotiva
          </RightCardTitle>
          <Content>
            Nossas equipes formadas por peritos com experiência de <strong>mais de 10 anos
            em vistorias automotivas</strong>, verificam mais de 100 itens do nosso checklist,
            garantindo ainda mais qualidade das vistorias.
          </Content>
          <Content>
            Já estamos presentes nas capitais e regiões metropolitanas da Bahia, Sergipe,
            Pernambuco, Paraíba, Rio Grande do Norte, Amazonas e Roraima.
            <br />
            A Autovalid faz parte do grupo Segsat, empresa que atua há 25 anos no ramo
            de tecnologia automotiva no Brasil.
          </Content>
        </Card>
      </CardsContainer>
    </RootGrid>
  );
};

export default AboutUs;